import React from 'react';
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from './4.png';

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? 'display' : 'display-none';
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === 'all'
      ? 'opacity-in'
      : 'opacity-out';
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 330 360"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_3401"
            data-name="3401"
            points="194.5 67.5 222.5 40.5 241.5 59.5 222.5 78.5 217.5 74.5 209.5 82.5 194.5 67.5"
          />
          <polygon
            id="_3402"
            data-name="3402"
            points="167.5 94.5 194.5 67.5 217.5 90.5 198.5 109.5 194.5 106.5 185.5 114.5 167.5 94.5"
          />
          <polygon
            id="_3409"
            data-name="3409"
            points="190.5 235.5 216.5 261.5 195.5 285.5 167.5 257.5 190.5 235.5"
          />
          <polygon
            id="_3410"
            data-name="3410"
            points="232.5 284.5 229.5 287.5 238.5 296.5 223.5 312.5 195.5 285.5 213.2 265.3 232.5 284.5"
          />
          <polygon
            id="_3413"
            data-name="3413"
            points="114.5 252.5 134.5 234.5 161.5 261.5 145.5 276.5 137.5 268.5 133.5 272.5 114.5 252.5"
          />
          <polygon
            id="_3414"
            data-name="3414"
            points="86.5 224.5 106.5 206.5 134.5 234.5 114.5 252.5 86.5 224.5"
          />
          <polygon
            id="_3417"
            data-name="3417"
            points="92.5 114.5 111.5 95.5 133.5 118.5 106.5 145.5 87.5 126.5 95.5 118.5 92.5 114.5"
          />
          <polygon
            id="_3418"
            data-name="3418"
            points="137.5 68.5 161.5 90.5 133.5 118.5 110.5 95.5 137.5 68.5"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_3404"
            data-name="3404"
            points="129.5 133.5 147.5 114.5 170.5 135.5 159.5 146.5 156.5 143.5 149.5 150.5 129.5 133.5"
          />
          <polygon
            id="_3405"
            data-name="3405"
            points="110.5 151.5 129.5 132.5 153.5 155.5 134.5 173.5 110.5 151.5"
          />
          <polygon
            id="_3407"
            data-name="3407"
            points="152.5 197.5 162.5 207.5 159.5 210.5 167.5 219.5 148.5 239.5 129.5 219.5 152.5 197.5"
          />
          <polygon
            id="_3408"
            data-name="3408"
            points="170.5 215.5 190.5 235.5 167.5 257.5 148.5 239.5 170.5 215.5"
          />
          <polygon
            id="_3411"
            data-name="3411"
            points="161.5 298.5 180.5 280.5 199.5 298.5 180.5 318.5 161.5 298.5"
          />
          <polygon
            id="_3412"
            data-name="3412"
            points="141.5 280.5 161.5 260.5 180.5 280.5 161.5 299.5 141.5 280.5"
          />
          <polygon
            id="_3415"
            data-name="3415"
            points="78.5 190.5 100.5 190.5 100.5 200.5 106.5 206.5 86.5 224.5 78.5 216.5 73.5 216.5 73.5 199.5 78.5 199.5 78.5 190.5"
          />
          <polygon
            id="_3416"
            data-name="3416"
            points="73.5 135.5 78.5 135.5 87.5 126.5 106.5 145.5 100.5 150.5 100.5 162.5 77.5 162.5 77.5 152.5 73.5 152.5 73.5 135.5"
          />
          <polygon
            id="_3419"
            data-name="3419"
            points="148.5 60.5 158.5 50.5 180.5 71.5 161.5 90.5 141.6 72.2 151.5 63.5 148.5 60.5"
          />
          <polygon
            id="_3420"
            data-name="3420"
            points="179.5 33.5 199.5 52.5 180.5 70.5 161 52 179.5 33.5"
          />
        </g>
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_3403"
            data-name="3403"
            points="175.5 124.5 172.5 120.5 163.6 129.2 148.5 114.5 167.5 95.5 185.5 114.5 175.5 124.5"
          />
          <polygon
            id="_3406"
            data-name="3406"
            points="110.5 200.5 129.5 181.5 141.5 192.5 137.5 197.5 145.3 204.4 129.5 219.5 110.5 200.5"
          />
        </g>
      </g>
      <g id="text">
        <g id="en" className={shouldDisplayByLang("en")}>
          <text transform="translate(217.5 170.8)" font-size="10" fill="#58595b" font-family="Termina-Bold, Termina Bold" font-weight="700">4th <tspan x="16.1" y="0" letter-spacing="-0.02em">F</tspan><tspan x="20.8" y="0">loor</tspan></text>
          <text transform="translate(240.8 81.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3401</text>
          <text transform="translate(149.1 34.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3420</text>
          <text transform="translate(131.1 52.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3419</text>
          <text transform="translate(108.5 74.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3418</text>
          <text transform="translate(82.3 101.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3417</text>
          <text transform="translate(214 108.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3402</text>
          <text transform="translate(189.1 132.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3403</text>
          <text transform="translate(171.1 150.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3404</text>
          <text transform="translate(152.8 169.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3405</text>
          <text transform="translate(152.8 185.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3406</text>
          <text transform="translate(170.1 203.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3407</text>
          <text transform="translate(189.5 222.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3408</text>
          <text transform="translate(212.5 245.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3409</text>
          <text transform="translate(240 273.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3410</text>
          <text transform="translate(155.3 321.4)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3411</text>
          <text transform="translate(136.5 302.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3412</text>
          <text transform="translate(115.3 281.4)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3413</text>
          <text transform="translate(86.5 252.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3414</text>
          <text transform="translate(57.8 215.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3415</text>
          <text transform="translate(52.8 144.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3416</text>
        </g>
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text transform="translate(218.1 171.7)" font-size="10" fill="#58595b" font-family="Termina-Bold, Termina Bold"><tspan font-weight="700">4</tspan><tspan x="5.1" y="0" font-family="STHeitiTC-Medium, STHeitiTC Medium">楼</tspan></text>
          <text transform="translate(240.8 81.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3401</text>
          <text transform="translate(149.1 34.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3420</text>
          <text transform="translate(131.1 52.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3419</text>
          <text transform="translate(108.5 74.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3418</text>
          <text transform="translate(82.3 101.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3417</text>
          <text transform="translate(214 108.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3402</text>
          <text transform="translate(189.1 132.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3403</text>
          <text transform="translate(171.1 150.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3404</text>
          <text transform="translate(152.8 169.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3405</text>
          <text transform="translate(152.8 185.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3406</text>
          <text transform="translate(170.1 203.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3407</text>
          <text transform="translate(189.5 222.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3408</text>
          <text transform="translate(212.5 245.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3409</text>
          <text transform="translate(240 273.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3410</text>
          <text transform="translate(155.3 321.4)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3411</text>
          <text transform="translate(136.5 302.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3412</text>
          <text transform="translate(115.3 281.4)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3413</text>
          <text transform="translate(86.5 252.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3414</text>
          <text transform="translate(57.8 215.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3415</text>
          <text transform="translate(52.8 144.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3416</text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text transform="translate(217.3 172.3)" font-size="11" fill="#58595b" font-family="Helvetica-Bold, Helvetica" font-weight="700">4-Й ЭТАЖ</text>
          <text transform="translate(240.8 81.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3401</text>
          <text transform="translate(149.1 34.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3420</text>
          <text transform="translate(131.1 52.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3419</text>
          <text transform="translate(108.5 74.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3418</text>
          <text transform="translate(82.3 101.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3417</text>
          <text transform="translate(214 108.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3402</text>
          <text transform="translate(189.1 132.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3403</text>
          <text transform="translate(171.1 150.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3404</text>
          <text transform="translate(152.8 169.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3405</text>
          <text transform="translate(152.8 185.9)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3406</text>
          <text transform="translate(170.1 203.3)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3407</text>
          <text transform="translate(189.5 222.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3408</text>
          <text transform="translate(212.5 245.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3409</text>
          <text transform="translate(240 273.1)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3410</text>
          <text transform="translate(155.3 321.4)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3411</text>
          <text transform="translate(136.5 302.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3412</text>
          <text transform="translate(115.3 281.4)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3413</text>
          <text transform="translate(86.5 252.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3414</text>
          <text transform="translate(57.8 215.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3415</text>
          <text transform="translate(52.8 144.6)" font-size="5.88" fill="#808184" font-family="Helvetica, Helvetica">3416</text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/c/4.js